/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2016, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../../DynamicFileLoader',
	'../nls/StringResources'
], function(Class, DynamicFileLoader, stringResources) {
	'use strict';

	var Action = Class.extend({
		/**
		 * if necessary set visibility on condition,
		 * extra options parameter can be passed in
		 */
		isItemVisible: function() {
			return true;
		},

		/**
		 * Callback when select a context menu item
		 *
		 * @param context {object}
		 * */
		onSelectItem: function(context) {
			var oTarget = context.target;
			let result;
			switch (oTarget.itemId) {
				case 'com.ibm.bi.dashboard.dataSources.relinkDataSource': {
					const oActiveObject = oTarget.activeObject;
					if (oActiveObject) {
						const dashboard = context.glassContext.appController.getCurrentContentView().getDashboardApi();
						result = dashboard.getGlassSvc('.ContentDialogFactory').then((dialogFactory) => {
							return new Promise((resolve, reject) => {
								const dialogOptions = this._getRelinkDlgOptions({
									'dashboard': dashboard,
									'dataSource': oActiveObject.dataSource,
									'dataSourceName': oActiveObject.dataSourceName
								});
								const openDialog = dialogFactory.createOpenDialog({
									...dialogOptions,
									resolve,
									reject
								});
								openDialog.open();
								return openDialog;
							});
						});
					}
					break;
				}
				default:
					//Default behavior
			}
			return result;
		},

		_getRelinkDlgOptions: function(options) {
			const supportedTypes = ['module', 'dataSet2', 'uploadedFile', 'package'];
			const filtersByType =  ['folder|package|module|dataSet2|uploadedFile'];
			const dialogOptions = {
				'primaryBtnText': stringResources.get('dlg_use'),
				'typesToOpen': supportedTypes,
				'dialogTitle': stringResources.get('dlg_RelinkDataSourceTitle', {
					'dataSourceName': options.dataSourceName
				}),
				'filtersByTypes': filtersByType,
				'multiSelect': false,
				'onOpenCallback': this._onOpenCallback.bind({
					dashboard: options.dashboard,
					dataSource: options.dataSource
				})
			};
			options.dashboard.prepareGlassOptions(dialogOptions);
			return dialogOptions;
		},

		_onOpenCallback: function(selectedItem) {
			if (selectedItem && selectedItem.length > 0) {
				const item = selectedItem[0];
				const oNewDataSourceObj = {
					'assetId': item.id,
					'name': item.defaultName,
					'type': item.type,
					'searchPath': item.searchPath
				};

				const dataSourcesSvc = this.dashboard.getFeature('dataSources.deprecated');
				dataSourcesSvc.relink(this.dataSource, oNewDataSourceObj);
			}
		}
	});

	return Action;
});
